import React from 'react';
import SolgariLogo from '@/public/icons/solgari-logos/solgari-logo';

const CopilotHeader = () => {
  return (
    <div className="solgari-copilot-header">
      <SolgariLogo />
      <span className="logo-text">Solgari Copilot</span>
    </div>
  );
};

export default CopilotHeader;
